module.exports = __webpack_public_path__ + "img/dp3.467f0b4a.png";